import { Editor } from 'slate';
import { isImage, isImageUrl } from '../helpers';
import { insertImage } from '../transformers';

// Custom plugin to facilitate images in Slate editor
export const withImages = (editor: Editor): Editor => {
	const { insertData, isVoid } = editor;

	// Images are 'void' in editor
	editor.isVoid = (element) => isImage(element) || isVoid(element);

	// Insert images in editor
	editor.insertData = (data) => {
		const text = data.getData('text/plain');
		const files = Array.from(data.files);

		if (files.length) {
			files.forEach((file) => {
				const [mime] = file.type.split('/');
				if (mime !== 'image') return;

				const reader = new FileReader();

				reader.addEventListener('load', () => {
					const url = reader.result as string;
					insertImage(editor, url);
				});
				reader.readAsDataURL(file);
			});
		} else if (isImageUrl(text)) {
			insertImage(editor, text);
		} else {
			insertData(data);
		}
	};

	return editor;
};
